import React from 'react';
import { Link } from 'react-router-dom';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { util, config } from '../_helpers';
import { toast } from "../_components/Toast";
import { accountService } from '../_services';
import { gapi } from 'gapi-script';
import { GoogleLogin } from 'react-google-login';

function Register({ history }) {
    const initialValues = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        password: '',
        confirmPassword: '',
        profilePic: '',
        acceptTerms: true
    };
    const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

    const initGoogleClient = () => {
        gapi.client.init({
            clientId: config.Google_Client_Id,
            scope: ['email']
        });
    }
    gapi.load('client:auth2', initGoogleClient);

    const redirectPostSuccess = (token) => {
        let redirectUrl = util.getParameterByName('redirect');
        window.location.href = redirectUrl + '?token=' + token;
    }

    const validationSchema = Yup.object().shape({
        firstName: Yup.string()
            .required('First Name is required'),
        email: Yup.string()
            .email('Email is invalid')
            .required('Email is required'),
        phone: Yup.string()
            .matches(phoneRegExp, 'Phone is invalid')
            .required('Phone is required'),
        password: Yup.string()
            .min(6, 'Password must be at least 6 characters')
            .required('Password is required'),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref('password'), null], 'Passwords must match')
            .required('Confirm Password is required'),
        acceptTerms: Yup.bool()
            .oneOf([true], 'Accept Terms & Conditions is required')
    });

    const onSubmit = (fields, { setStatus, setSubmitting }) => {
        setStatus && setStatus();
        accountService.register(fields)
            .then((res) => {
                redirectPostSuccess(res.user.token);
            })
            .catch(error => {
                setSubmitting(false);
                toast.error(error);
            });
    }

    const gLoginSuccess = (gData) => {
        if (gData.profileObj) {
            let newUser = initialValues;
            newUser.firstName = gData.profileObj.givenName;
            newUser.lastName = gData.profileObj.familyName;
            newUser.email = gData.profileObj.email;
            newUser.phone = "";
            newUser.password = gData.tokenId;
            newUser.confirmPassword = gData.tokenId;
            newUser.profilePic = gData.imageUrl;
            newUser.isEmailVerified = true;
            newUser.acceptTerms = true;
            newUser.thirdPartySignup = "GOOGLE";
            onSubmit(newUser, { setStatus: () => true, setSubmitting: () => true });
        }
    }

    const gLoginFailed = (err) => {
        console.log('google log in failed', err);
    }

    return (
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
            {({ errors, touched, isSubmitting }) => (
                <Form>
                    <h5 className="card-header">Create New Account</h5>

                    <div className="d-flex" style={{ gap: "15px" }}>
                        <div className="form-group flex-fill">
                            <label>First Name</label>
                            <Field name="firstName" type="text" className={'form-control' + (errors.firstName && touched.firstName ? ' is-invalid' : '')} placeholder="First Name" />
                            <ErrorMessage name="firstName" component="div" className="invalid-feedback" />
                        </div>
                        <div className="form-group flex-fill">
                            <label>Last Name</label>
                            <Field name="lastName" type="text" className={'form-control' + (errors.lastName && touched.lastName ? ' is-invalid' : '')} placeholder="Last Name" />
                            <ErrorMessage name="lastName" component="div" className="invalid-feedback" />
                        </div>
                    </div>

                    <div className="form-group">
                        <label>Email Address</label>
                        <Field name="email" type="text" className={'form-control' + (errors.email && touched.email ? ' is-invalid' : '')} placeholder="Email" />
                        <ErrorMessage name="email" component="div" className="invalid-feedback" />
                    </div>

                    <div className="form-group">
                        <label>Phone Number</label>
                        <Field name="phone" type="text" className={'form-control' + (errors.phone && touched.phone ? ' is-invalid' : '')} placeholder="Phone" />
                        <ErrorMessage name="phone" component="div" className="invalid-feedback" />
                    </div>

                    <div className="d-flex" style={{ gap: "15px" }}>
                        <div className="form-group flex-fill">
                            <label>Password</label>
                            <Field name="password" type="password" className={'form-control' + (errors.password && touched.password ? ' is-invalid' : '')} placeholder="Password" />
                            <ErrorMessage name="password" component="div" className="invalid-feedback" />
                        </div>
                        <div className="form-group flex-fill">
                            <label>Confirm Password</label>
                            <Field name="confirmPassword" type="password" className={'form-control' + (errors.confirmPassword && touched.confirmPassword ? ' is-invalid' : '')} placeholder="Confirm" />
                            <ErrorMessage name="confirmPassword" component="div" className="invalid-feedback" />
                        </div>
                    </div>

                    <div className="form-group">
                        <button type="submit" disabled={isSubmitting} className="btn btn-primary">
                            {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                            Register Now
                        </button>
                    </div>

                    <div className="form-group d-flex justify-content-center align-items-center mt-3">
                        <Link to="login" className="btn btn-link p-0">
                            Already have an account? Sign In
                        </Link>
                    </div>

                    {config.Google_Client_Id && (
                        <div className="mt-4 pt-3 border-top border-secondary">
                            <div style={{ textAlign: "center" }} className="form-group">
                                <GoogleLogin
                                    clientId={config.Google_Client_Id}
                                    buttonText="SIGNUP WITH GOOGLE"
                                    onSuccess={gLoginSuccess}
                                    onFailure={gLoginFailed}
                                    cookiePolicy={'single_host_origin'}
                                    theme="dark"
                                />
                            </div>
                        </div>
                    )}

                    <div style={{ fontSize: "0.7em", color: "#666", textAlign: "center", marginTop: "20px" }}>
                        <span>&#169;</span>{new Date().getFullYear() + " " + config.Provider}. All Rights Reserved.
                    </div>
                </Form>
            )}
        </Formik>
    )
}

export { Register };